var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.selectedStepHeader.header.length > 0)?_c('step-header-component',{attrs:{"headerText":_vm.selectedStepHeader.header,"subHeaderText":_vm.selectedStepHeader.subHeader}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }